<template>
    <div>
        <el-dialog :visible.sync="newDialog"  center :close-on-click-modal="true" @close="closeDialog"
            custom-class="dialog_normalsuo dialog_normalsuo_update"  :append-to-body="true">
            <div>
                <div class="detail_cont">
                    <div class="flex_center margin-bottom20"><img style="width: 5.7142857rem;height: 5rem;" src="../../../assets/dialogIcoImg/updateIcon.png" alt=""></div>
                    <h3>{{ $t('ListofResults.Update') }}</h3>
                    <div class="detail_cont_text" style="padding: 0px;">
                       {{ $t('ListofResults.Iftheavailable') }}
                        <br />
                        <br />
                         {{ $t('ListofResults.Abusinesscredit') }}
                        </div>

                </div>
            </div>
            <div class="flex_center" style="margin-top: 20px;">
                <el-button class="btn_export btn_exportCCC" @click="onSubmitkoudian()">{{ $t('ListofResults.Update') }}</el-button>
                <el-button v-if=" $store.state.app.equityType<PointDetail" class="btn_export" @click="onSubmitquxiao()">{{ $t('navigationBar.AddCredits') }}</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { saveUserConsumption, getPointAndHour} from "@/api/userApi";

export default {
    props: {
        suoClose: {
            type: Boolean,
            //   default: false,
        },
        obj: {
            type: Object,
        },
        update: {
            type: Object,
        },
        ComapnyName:{
            type:String
        }
    },
    data() {
        return {
            PointDetail:0,
            //page: this.currentPage

            token: sessionStorage.getItem('token'),
        };
    },
    computed: {
        newDialog: {
            get() {
             if(this.suoClose){
                      this.getgetPointAndHour()
             }
                return this.suoClose;
            },
            set() { },
        },

    },
    destroyed() {
        // bus.$off('handleShowLogin');
    },
    mounted() {
       
    },
    methods: {
        getgetPointAndHour(){
          
            getPointAndHour([{
                 companyAaaid: this.$route.query.id3a,
                countryCode:  this.$route.query.companyCountry,
                companyName:this.ComapnyName
            }]).then(res=>{
                if(res.code==200){
                    this.PointDetail=res.data.point
                    
                }
            })
        },
        //关闭弹窗
        closeDialog() {
            this.$emit('closeCloseDialog', false);
        },
        onSubmitkoudian() {
            this.newDialog = false;
            this.$emit('closeCloseDialog', false);
            const base = JSON.parse(localStorage.getItem("CompanyBase"));
            
            saveUserConsumption({
                companyAaaid: this.$route.query.id3a,
                countryCode:  base.base.countryFlag,
                companyName:this.ComapnyName
            }).then(res => {
                if (res.code == 200) {
            this.$parent.toolsConfig.update.isActive = false
            this.$router.go(0)
            this.$parent.UpdateStatus=3
                    this.$message({
                        message:'Available Credits: -'+ res.data.consumptionPoints,
                        type: 'success'
                    })
                } else {
                    this.$message.error(res.msg);
                }
            })
            //  this.$emit('closeCloseDialog1', true);


        },
        onSubmitquxiao() {
      this.$router.push({
        path: '/index/addCredit',
      });
            // this.newDialog = false;
            // this.$emit('closeCloseDialog', false);
            let that = this;
            let userinfo = JSON.parse(localStorage.getItem('userInfo')).userInfo;


        },
    },
};
</script>
<style scoped>
.detail_cont {
    max-height: 68%;
    overflow: auto;

}



</style>
